<script setup>
import { useStore } from 'vuex'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

const store = useStore()
const route = useRoute()

const showSideBar = computed(() => store.state.comment.show)
const commentItems = computed(() => store.state.comment.items)
const currentStabSchematisationStageId = computed(
  () => store.getters['stabSchematisationStage/currentStabSchematisationStageId']
)
const show = computed(() => !route.meta.hideSideBar)
const stateComments = computed(() => {
  return isInStabSchematisationStageTag.value
    ? commentItems.value.filter(
        (item) => item.stab_schematisation_stage === currentStabSchematisationStageId.value
      )
    : commentItems.value
})
const isInStabSchematisationStageTag = computed(() => route.name === 'schematisation-stage')

const setCurrentTab = () => store.dispatch('comment/setCurrentTab')
const toggleShow = () => store.dispatch('comment/toggleShow')

watch(
  () => show.value,
  (newValue) => {
    if (!newValue) {
      toggleShow(false)
      setCurrentTab(null)
    }
  }
)
</script>

<template>
  <div>
    <v-btn
      v-if="show"
      @click="toggleShow()"
      variant="text"
      class="text-none"
      prepend-icon="mdi-comment-text-outline"
    >
      {{ showSideBar ? 'Hide' : 'Show' }} comment
    </v-btn>
    <v-badge
      v-if="stateComments.length"
      :content="stateComments.length"
      max="9"
      color="white"
      class="mb-3 mr-5"
    >
    </v-badge>
  </div>
</template>
